import { styled } from '@/stitches.config';

import { Box } from '@/common/components';

export const StyledContainer = styled(Box, {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '$4',
});

export const StyledDateContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});

export const StyledSelectedRange = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledDate = styled(Box, {
  marginLeft: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledSelectContainer = styled(Box, {
  marginLeft: '$4',
});
